import { SETTINGS_MENU_DATA } from "./settings-menu-data";

export const settingsMenuPermissions = SETTINGS_MENU_DATA.flatMap(
  (block) => block.items,
)
  .flatMap((item) => item.requiredAtLeastOnePermission)
  .filter((item): item is string => item !== undefined);
